import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Delete promo code"),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-3 mb-3" }, " This action is irreversible, are you sure you want to delete this entry? ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreatePromoCodesModal = _resolveComponent("CreatePromoCodesModal")!
  const _component_AppToolbarTable = _resolveComponent("AppToolbarTable")!
  const _component_DeleteConfirmDialog = _resolveComponent("DeleteConfirmDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_CreatePromoCodesModal, {
      "edit-data": _ctx.editData?.id ? _ctx.editData : null,
      opened: _ctx.openedForm,
      countries: _ctx.countries,
      regions: _ctx.regions,
      subregions: _ctx.subregions,
      users: _ctx.users,
      bundles: _ctx.bundles,
      plans: _ctx.plans,
      onSubmit: _ctx.onSubmit,
      onHide: _ctx.cleanData
    }, null, 8, ["edit-data", "opened", "countries", "regions", "subregions", "users", "bundles", "plans", "onSubmit", "onHide"]),
    _createVNode(_component_AppToolbarTable, {
      "table-head-table": _ctx.tableHead,
      "table-body": _ctx.rows,
      "table-title": 'Promo Codes',
      "table-head-tabs": _ctx.tabs,
      "total-rows": _ctx.totalRowsCount,
      "pagination-capture-key": _ctx.currentSortKeyLocationName,
      "current-page": _ctx.viewConfiguration.page,
      "per-page": _ctx.viewConfiguration.perPage,
      onChangeViewConfiguration: _ctx.changeViewConfiguration,
      onChangeTab: _ctx.changeTabHandler,
      onSort: _ctx.changeSorting,
      onOpenForm: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openedForm = true)),
      onEditItem: _ctx.onEdit,
      onRemoveItem: _ctx.onRemove
    }, null, 8, ["table-head-table", "table-body", "table-head-tabs", "total-rows", "pagination-capture-key", "current-page", "per-page", "onChangeViewConfiguration", "onChangeTab", "onSort", "onEditItem", "onRemoveItem"]),
    _createVNode(_component_DeleteConfirmDialog, {
      opened: _ctx.deleteForm,
      loading: _ctx.isLoading,
      onConfirm: _ctx.deleteHandler,
      onCancel: _ctx.cleanData
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["opened", "loading", "onConfirm", "onCancel"])
  ], 64))
}